/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { isPointInsideDocumentView } from "selectors/documentViewSelectors";
import { PinchZoomEnabler } from "./PinchZoomEnabler";

class WheelPinchZoomEnabler extends PinchZoomEnabler {
  constructor(event) {
    super(event);
    this.clientX = event.clientX;
    this.clientY = event.clientY;
    this.timeoutKey = null;
    this.timeoutCallback = null;
  }

  setTimeoutParams(timeoutKey = null, timeoutCallback = null) {
    this.setTimeoutKey(timeoutKey);
    if (this.timeoutCallback) {
      clearTimeout(this.timeoutCallback);
    }
    this.timeoutCallback = timeoutCallback;
  }

  setTimeoutKey(timeoutKey = null) {
    this.timeoutKey = timeoutKey;
  }

  getTimeoutKey(timeoutKey) {
    return this.timeoutKey;
  }
  setScaleFactor() {}

  didWheelEventOriginFromSamePoint({ clientX, clientY }) {
    return this.clientX === clientX && this.clientY === clientY;
  }

  isEventToBeConsumendByEnabler({ type }) {
    return type === "wheel";
  }

  getNewZoomLevel(event, oldZoomLevel) {
    let newZoomLevel = oldZoomLevel;
    if (event.deltaY < 0) {
      newZoomLevel = oldZoomLevel + 0.05;
    } else {
      newZoomLevel = oldZoomLevel - 0.05;
    }
    return newZoomLevel;
  }

  getCenterX(event) {
    return event.clientX;
  }

  getCenterY(event) {
    return event.clientY;
  }

  shouldStartPinchZoom(event, stores) {
    return isPointInsideDocumentView(stores, event.clientX, event.clientY);
  }
}

export { WheelPinchZoomEnabler };
